import { v4 as uuidv4 } from "uuid";
import { Variable } from "../interfaces/flow/variable/Variable";
import { WebRequestAction } from "../interfaces/flow/action/WebRequestAction";

export const newVariable = (key: string, value: string):Variable  => {
  return { key:key,value:value };
};

export const addNewVariable = (action: WebRequestAction, key: string, value: string) => {
  action.variables?.push(newVariable(key,value));
  if (!action.variables) {
    action.variables = [newVariable(key,value)];
  }
};

export const addVariables = (action: WebRequestAction, variables: { key: string; value: string }[]) => {
  variables.forEach((variable) => {
    addNewVariable(action,variable.key, variable.value);
  });
};